<template>
    <modal size="lg" :height-max="false" @close="reset(); $emit('close')" ref="modal" :is-closeable="isCloseable" id="editLocationModal">
        <template v-slot:title>
            <h3 class="modal-title">Edit Location</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">Company: </span>{{ location.company.name }}</div>
                    <div><span class="text-muted">Location: </span>{{ location.name }}</div>
                </div>
            </div>

            <form-errors :errors="formErrors"/>

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <form>
                                <form-input label="Location Name" v-model="formData.name" :errors="errors.name" type="text" :maxlength="100"/>
                                <div class="form-row">
                                    <div class="col-6">
                                        <form-input label="POS ID (Optional)" v-model="formData.external_pos_id" :errors="errors.external_pos_id" type="text" :maxlength="20"/>
                                    </div>
                                    <div class="col-6">
                                        <form-input label="Phone Number (Optional)" v-model="formData.phone_number" type="phone" :errors="errors.phone_number" />
                                    </div>
                                </div>
                                <form-input label="Address 1" v-model="formData.address_1" :errors="errors.address_1" type="text" :maxlength="100"/>
                                <form-input label="Address 2 (Optional)" v-model="formData.address_2" :errors="errors.address_2" type="text" :maxlength="100"/>
                                <form-input label="City" v-model="formData.city" :errors="errors.city" type="text" :maxlength="100"/>

                                <div class="form-row">
                                    <div class="col-6">
                                        <form-input label="State" v-model="formData.state" :errors="errors.state" type="select" :options="stateOptions"/>
                                    </div>

                                    <div class="col-6">
                                        <form-input label="Zip Code" :maxlength="5" v-model="formData.postal_code" :errors="errors.postal_code" type="text" inputmode="tel" />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </slot>

        <template v-slot:footer>
            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import STATES from '@/states'

export default {
    props: ['client', 'location'],
    mixins: [FormMixin, ModalMixin],
    components: {},
    data() {
        return {
            formData: this.makeFormData(),
        }
    },
    watch: {
        location() {
            this.reset()
        }
    },
    mounted() {},
    computed: {
        stateOptions() {
            const opts = []
            STATES.forEach(s => {
                opts.push({text: s.name.toUpperCase(), value: s.abbreviation})
            })
            return opts
        },
    },
    methods: {
        makeFormData() {
            let location = JSON.parse(JSON.stringify(this.location))
            const data = {
                name: location.name,
                external_pos_id: location.external_pos_id,
                address_1: location.address_1,
                address_2: location.address_2,
                city: location.city,
                state: location.state,
                postal_code: location.postal_code,
                phone_number: location.phone_number
            }
            return data
        },
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            return this.$api.patch(`/clients/${this.client.id}/settings/locations/${this.location.id}`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        }
    }
}
</script>
